import isEqual from 'lodash-es/isEqual'
import { useEffect } from 'react'

import { useTelemetryCredentials } from '@/feature/telemetry/api/useMyTelemetryCredentials'

import { usePrevious } from '@/lib/core/hooks/usePrevious'

import { useTelemetryStore } from '../store/telemetry'

const AssetTelemetryConnectionMaintainer = () => {
  const { data: credentials } = useTelemetryCredentials()
  const prevCredentials = usePrevious(credentials)

  const socket = useTelemetryStore((state) => state.socket(credentials?.telemetryFleetName))

  const startListeningToSocket = useTelemetryStore((state) => state.startListeningToSocket)
  const closeSocket = useTelemetryStore((state) => state.closeSocket)

  useEffect(() => {
    if (!isEqual(credentials, prevCredentials) && socket && credentials?.telemetryToken) {
      closeSocket(credentials.telemetryFleetName)
    }
  }, [credentials, socket])

  useEffect(() => {
    if (!socket && credentials?.telemetryFleetName && credentials?.telemetryToken) {
      return startListeningToSocket(credentials.telemetryFleetName, credentials.telemetryToken)
    }
  }, [credentials, socket])

  return null
}

export const AssetTelemetryConnection = () => {
  const activeListeners = useTelemetryStore((state) => state.activeListeners)

  return activeListeners > 0 ? <AssetTelemetryConnectionMaintainer /> : null
}
